// api/courses.js
import apiClient from "./client";

export const coursesApi = {
  // All published courses with enrollment metadata + computed curriculum stats.
  getAll: () => apiClient.get("/api/courses"),
  // One course with its modules/episodes (curriculum).
  getCourse: (courseSlug) => apiClient.get(`/api/courses/${courseSlug}`),
  getEpisode: (courseSlug, episodeSlug) =>
    apiClient.get(`/api/courses/${courseSlug}/episodes/${episodeSlug}`),
  saveProgress: (courseSlug, episodeSlug, data) =>
    apiClient.post(
      `/api/courses/${courseSlug}/episodes/${episodeSlug}/progress`,
      data,
    ),
  getProgress: (courseSlug) =>
    apiClient.get(`/api/courses/${courseSlug}/progress`),
  // Pre-launch waitlist signup (public, no auth).
  joinWaitlist: (data) => apiClient.post("/api/waitlist", data),
};
